const theme = {
  token: {
    /* 🎯 Brand */
    colorPrimary: '#6E62C4',
    colorPrimaryHover: '#5B51B2',
    colorPrimaryActive: '#4B418F',

    colorInfo: '#6E62C4',
    colorSuccess: '#3BB273',
    colorWarning: '#F2B705',
    colorError: '#E05757',

    /* 🖋 Texto */
    colorTextBase: '#1E1E2D',
    colorTextSecondary: '#5A5D7A',
    colorTextDisabled: '#A0A3BD',

    /* 🧱 Fondos */
    colorBgBase: '#F7F8FC',
    colorBgLayout: '#F3F4FA',
    colorBgContainer: '#FFFFFF',

    /* 📐 Bordes */
    colorBorder: '#E3E5F1',
    borderRadius: 12,

    /* 🔠 Tipografía */
    fontFamily:
      '"Darker Grotesque", -apple-system, BlinkMacSystemFont, "Segoe UI", Inter, Roboto, Helvetica, Arial, sans-serif',

    fontSize: 18, // Darker Grotesque se ve mejor un pelín más grande
    lineHeight: 1.45,

    /* 🧘 Espaciado */
    controlHeight: 44,

    /* 📱 Breakpoints personalizados */
    screenXS: 480,
    screenSM: 576,
    screenMD: 768,
    screenLG: 1025, // Para que tablets en horizontal (aprox 1024px) sigan viéndose como móvil/vertical
    screenXL: 1200,
    screenXXL: 1600,
  },

  components: {
    /* 🔘 Botones */
    Button: {
      controlHeight: 44,
      borderRadius: 12,
      fontWeight: 600,
      primaryShadow:
        '0 6px 16px rgba(110, 98, 196, 0.25)',
    },

    /* ✍️ Inputs */
    Input: {
      controlHeight: 44,
      borderRadius: 10,
      fontWeight: 500,
    },

    Select: {
      controlHeight: 44,
      borderRadius: 10,
      fontWeight: 500,
    },

    DatePicker: {
      controlHeight: 44,
      borderRadius: 10,
    },

    /* 🧾 Cards */
    Card: {
      borderRadiusLG: 16,
      paddingLG: 24,
      boxShadow:
        '0 8px 24px rgba(0, 0, 0, 0.04)',
    },

    /* 📊 Tablas */
    Table: {
      headerBg: '#F3F4FA',
      headerColor: '#1E1E2D',
      rowHoverBg: '#F7F8FC',
      borderColor: '#E3E5F1',
      fontSize: 14,
    },

    /* 🧭 Layout */
    Layout: {
      bodyBg: '#F7F8FC',
      headerBg: '#FFFFFF',
      siderBg: '#FFFFFF',
    },

    /* 📂 Menú */
    Menu: {
      itemHeight: 46,
      itemSelectedBg: '#ECEBFA',
      itemSelectedColor: '#6E62C4',
      itemHoverColor: '#6E62C4',
      fontWeight: 600,
      borderRadius: 10,
    },

    /* ⚠️ Alerts */
    Alert: {
      borderRadius: 12,
      fontWeight: 500,
    },

    /* 🏷 Tags */
    Tag: {
      borderRadiusSM: 8,
      fontSizeSM: 12,
      fontWeight: 600,
    },
  },
};

export default theme;
